import { ImpulseElement, property, registerElement, target } from '@ambiki/impulse';
import type AwcAutocompleteElement from '@ambiki/impulse-view-components/dist/elements/autocomplete';
import { createHiddenInput } from 'helpers/form';

@registerElement('autopay-settings')
export default class AutopaySettingsElement extends ImpulseElement {
  /**
   * The HTML name attribute of the `invoice_consolidation_timing` field.
   */
  @property() invoiceConsolidationTimingName: string;

  @target() consolidationTimingContainer: HTMLElement;
  @target() consolidationTimingSelect: AwcAutocompleteElement;
  @target() invoiceConsolidationTimingHiddenField?: HTMLInputElement;

  consolidateInvoices(event: Event) {
    const checkbox = event.target;
    if (!(checkbox instanceof HTMLInputElement)) return;

    if (checkbox.checked) {
      this.invoiceConsolidationTimingHiddenField?.remove();
      this.consolidationTimingContainer.hidden = false;
      this.consolidationTimingSelect.required = true;
      this.consolidationTimingSelect.disabled = false;
    } else {
      // Override the value of `invoice_consolidation_timing` field so that when the checkbox is unchecked, we send an
      // empty value.
      this.appendInvoiceConsolidationTimingHiddenField();
      this.consolidationTimingContainer.hidden = true;
      this.consolidationTimingSelect.required = false;
      this.consolidationTimingSelect.disabled = true;
    }
  }

  private appendInvoiceConsolidationTimingHiddenField() {
    const hiddenInput = createHiddenInput(this.invoiceConsolidationTimingName, '');
    hiddenInput.setAttribute('data-target', `${this.identifier}.invoiceConsolidationTimingHiddenField`);
    if (this.invoiceConsolidationTimingHiddenField) return;

    this.consolidationTimingContainer.append(hiddenInput);
  }
}
